import React from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"

import Rating from "./Rating"
import ReviewListItem from "./ReviewListItem"
import { fetchReviews } from "./duck"

const NAVBAR_HEIGHT = 60
const SECTION_TITLE_HEIGHT = 66

@connect(
  state => ({
    companyId: state.companyId,
    productId: state.productId,
    reviews: state.reviews.model,
    rating: state.reviews.rating,
    fetchDone: state.reviews.fetchDone,
    fetchFailed: state.reviews.fetchFailed,
    fetchLoading: state.reviews.fetchLoading,
  }),
  dispatch => bindActionCreators({
    fetchReviews,
  }, dispatch)
)
export default class ReviewsListWidget extends React.PureComponent {
  state = {
    limit: 3,
  }
  subscriptions = []

  componentDidMount() {
    this._setupFetchOnWindowScrollHandler()
  }

  componentWillUnmount() {
    this.subscriptions.forEach(s => s.unsubscribe())
    this.subscriptions.length = 0
  }

  _setupFetchOnWindowScrollHandler() {
    const onWindowScroll = () => {
      if (!this._alreadyFetched && this._containerRef && st.domUtils.isElementInViewport(this._containerRef)) {
        this._alreadyFetched = true
        this.props.fetchReviews().then(() => {
          if (window.location.hash === "#reviews") {
            this.scrollToReviews()
          }
        })
      }
    }

    onWindowScroll()
    $(window).on("scroll", onWindowScroll)
    this.subscriptions.push({
      unsubscribe: () => $(window).off("scroll", onWindowScroll)
    })
  }

  scrollToReviews() {
    if (this._containerRef && this._containerRef.offsetTop) {
      setTimeout(() => {
        window.scrollTo(0, this._containerRef.offsetTop - NAVBAR_HEIGHT - SECTION_TITLE_HEIGHT)
      })
    }
  }

  handleShowMoreClick() {
    this.setState({ limit: this.state.limit + 10 })
  }

  handleAddMoreClick() {
    window.location.href = location.origin + `/reviews/new?` + st.encodeURIParams({
      company_id: this.props.companyId,
      product_id: this.props.productId,
    })
  }

  render() {
    const { reviews, rating, fetchDone, fetchFailed, fetchLoading, fetchReviews } = this.props
    console.log({ reviews: reviews, rating: rating, props: this.props })
    const { limit } = this.state
    const averageRating = (fetchDone && rating.reviews_size > 0) ? rating.average_rating : null
    const reviewsRatingPercentage = (fetchDone && rating.reviews_size > 0) ? {
      1: rating.reviews_rating_percentage.rate1,
      2: rating.reviews_rating_percentage.rate2,
      3: rating.reviews_rating_percentage.rate3,
      4: rating.reviews_rating_percentage.rate4,
      5: rating.reviews_rating_percentage.rate5,
    } : null

    return (
      <div className="ReviewsListWidget" ref={ref => this._containerRef = ref}>
        {fetchFailed && (
          <div className="alert alert-danger">{I18n.t("fe.common.loading_failed_message")} <a onClick={() => fetchReviews()}>{I18n.t("fe.common.click_to_load_again")}</a></div>
        )}
        {fetchLoading && (
          <div className="alert alert-info">{I18n.t("fe.common.loading_message")}</div>
        )}
        {(fetchDone && reviews.length === 0) && (
          <div className="ReviewsListWidget-content">
            {I18n.tt("fe.ReviewsListWidget.no_reviews_yet")} <a onClick={this.handleAddMoreClick.bind(this)}>{I18n.tt("fe.ReviewsListWidget.add_first_review")}</a>
          </div>
        )}
        {(fetchDone && reviews.length > 0) && (
          <div className="ReviewsListWidget-content">
            <div className="ReviewsListWidget-summary">

              <div className="ReviewsListWidget-summary-left">
                <div className="ReviewsSummary">
                  <div className="ReviewsSummary-inner">
                    <div className="ReviewsSummary-label">
                      {I18n.tt("fe.ReviewsListWidget.rating")}
                    </div>
                    <div className="ReviewsSummary-score">{averageRating}</div>
                    <div className="ReviewsSummary-total_count">
                      {I18n.tt("fe.ReviewsListWidget.total_count", {
                        count: rating.reviews_size,
                        formatted_count: <strong className="text-primary">{rating.reviews_size}</strong>,
                      })}
                    </div>
                  </div>
                </div>
              </div>

              <div className="ReviewsListWidget-summary-right">
                <div className="RatingsDistribution">
                  {[5,4,3,2,1].map(value => (
                    <div key={value} className="RatingsDistribution-item">
                      <div className="RatingsDistribution-item-rating"><Rating value={value} /></div>
                      <div className="RatingsDistribution-item-bar">
                        <div className="progress">
                          <div className="progress-bar" style={{ width: `${reviewsRatingPercentage[value] * 100}%` }}></div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

            </div>

            {reviews.slice(0, limit).map(review => (
              <ReviewListItem key={review.id} review={review} />
            ))}

            {reviews.length > limit && (
              <div className="ReviewsListWidget-show-more">
                <a className="btn btn-lg btn-primary" onClick={this.handleShowMoreClick.bind(this)}>
                  {I18n.t("fe.common.show_more")}
                </a>
              </div>
            )}
          </div>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/webpack/frontend/features/ReviewsListWidget/ReviewsListWidget.jsx